import { css } from '@linaria/core';
import { ellipsis } from 'polished';
import { breakpoints } from 'styles/utils';
export const darkArrow = "odules__Home__cards__RecentActivity_styles_tsx-darkArrow-d16evykj";
export const groupedActivityListStyles = "odules__Home__cards__RecentActivity_styles_tsx-groupedActivityListStyles-g1oo502j";

require("./RecentActivity.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RecentActivity.styles.tsx");